import { css, styled } from 'styles';
import { StyledSelectListItemWrapperProps, StyledSelectListProps } from './types';

export const disabledStyles = css`
  cursor: default;
  opacity: 0.5;
`;

export const focusStyles = css`
  &:focus {
    border-color: ${({ theme }) => theme.select.focus.border};
    box-shadow: ${({ theme }) => theme.shadow.highlight};
  }
`;

export const SelectListItemWrapper = styled.div<StyledSelectListItemWrapperProps>`
  height: ${({ $size, theme }) => ($size ? `${theme.element.height * $size}px` : undefined)};
`;

export const StyledSelectList = styled.div<StyledSelectListProps>`
  background-color: ${({ theme }) => theme.select.background};
  border: thin solid ${({ theme }) => theme.select.border};
  border-radius: ${({ theme }) => theme.radius.small};
  color: ${({ theme }) => theme.select.color};
  cursor: pointer;
  outline: none;
  overflow: hidden;
  transition: border-color ${({ theme }) => theme.transition.medium} ease-in-out,
    box-shadow ${({ theme }) => theme.transition.medium} ease-in-out;
  user-select: none;

  .os-host-overflow {
    ${SelectListItemWrapper} {
      margin-right: ${({ theme }) => theme.scrollbar.thumb.size}px;
    }
  }

  ${({ $disabled }) => $disabled && disabledStyles};
  ${({ $disabled }) => !$disabled && focusStyles};
`;

SelectListItemWrapper.displayName = 'SelectListItemWrapper';
StyledSelectList.displayName = 'SelectList.Styled';
